import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Description,
  StyledModalButton,
  useStyles,
} from "./CustomModal.styles";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useSelector } from "react-redux";
import { isMobileSelector } from "../../store/config/configurationSlice";

const CustomModal = (props) => {
  const { heading, description, buttonText, isOpen, close } = props;
  const classes = useStyles();
  const isMobile = useSelector(isMobileSelector);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    close();
  };
  useEffect(() => {
    setOpen(isOpen);
    // eslint-disable-next-line
  }, [props]);

  return (
    <div>
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        hideBackdrop={true}
        classes={{ root: classes.modalstyle }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box className={isMobile ? classes.mobilestyle : classes.style}>
          <div className={classes.align}>
            <div className={classes.iconspace}>
              <span className={classes.warnwrap}>
                <WarningAmberRoundedIcon className={classes.warn} />
              </span>
              <span className={classes.closewrap} onClick={handleClose}>
                <CloseIcon className={classes.close} />
              </span>
            </div>
            <div className={classes.headingspace}>
            <div className={isMobile ? classes.mobileheading : classes.heading}>{heading}</div>
            </div>
            <Description>{description}</Description>
            <div className={classes.buttonspace}>
              <StyledModalButton
                variant="contained"
                disableElevation
                onClick={handleClose}
              >
                {buttonText}
              </StyledModalButton>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default CustomModal;
